import React from 'react';
import PropTypes from 'prop-types';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import Span from '@deliveroo/consumer-component-library/components/Span';
import BackgroundImage from '@deliveroo/consumer-component-library/components/BackgroundImage';
import isRequiredIf from 'react-proptype-conditional-require';
import classnames from 'classnames';
import HomeIcon from '../HomeIcon';
import styles from './styles.scss';

const IMAGE_TYPE_ICON = 'DeliverooIcon';
const IMAGE_TYPE_IMAGE_SET = 'UIControlQueryResultOptionImageSet';

const HomeSuggestionRow = (props) => {
  const { image, children, onClick, isHighlighted, url, keyboardSelectActive } = props;
  const suggestionRowClasses = classnames(styles.suggestionRow, {
    [styles.highlighted]: isHighlighted,
    [styles.keyboardSelectActive]: keyboardSelectActive,
  });
  const Wrapper = url ? 'a' : 'button';
  return (
    <li className={suggestionRowClasses}>
      <Wrapper
        type={url ? null : 'button'}
        href={url}
        className={styles.wrapperTag}
        onClick={onClick}
      >
        <Spacer spacing="0 small 0 medium">
          {image.type === IMAGE_TYPE_IMAGE_SET && (
            <span className={styles.imageContainer}>
              <BackgroundImage src={image.default} />
            </span>
          )}
          {image.type === IMAGE_TYPE_ICON && (
            <HomeIcon name={image.name} fallbackImage={image.image} color="light-grey" />
          )}
        </Spacer>
        <Span>{children}</Span>
      </Wrapper>
    </li>
  );
};

HomeSuggestionRow.propTypes = {
  image: PropTypes.shape({
    default: isRequiredIf(
      PropTypes.string,
      (props) => props.image && props.image.type === IMAGE_TYPE_IMAGE_SET,
    ),
    name: isRequiredIf(
      PropTypes.string,
      (props) => props.image && props.image.type === IMAGE_TYPE_ICON,
    ),
  }),
  url: PropTypes.string,
  isHighlighted: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  keyboardSelectActive: PropTypes.bool,
};

HomeSuggestionRow.defaultProps = {
  image: undefined,
  isHighlighted: false,
  onClick: undefined,
  url: undefined,
  keyboardSelectActive: false,
};

export default HomeSuggestionRow;
